module.exports = __webpack_public_path__ + "static/media/platinum-card.ec97817a.png";